import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {RepairItem} from "../api";

export class RepairInventoryService extends RestService<RepairItem> {
    constructor(url: string) {
        if (url) {
            super(url)
        } else {
            super(REST_API_END_POINTS.REPAIR_INVENTORY)
        }
    }

    getHistory() {
        return this.instance.post(`${this.url}use_log`)
    }

    cancel() {
        return this.instance.post(`${this.url}cancel/`)
    }
}
